import { useState } from 'react';

function useClientResultCollaspe(needCollapse, initialIndex = 0) {
    const [openTarget, setOpenTarget] = useState(initialIndex);
    if (!needCollapse) {
        return {};
    }
    return { openTarget, updateCollapse: setOpenTarget };
}

export default useClientResultCollaspe;
